export default "<tc-grid [storeKey]=\"storeKey\"></tc-grid>\r\n";